
    const html = "<div class=progress-bar ng-class=\"type && 'progress-bar-' + type\" role=progressbar aria-valuenow={{value}} aria-valuemin=0 aria-valuemax={{max}} ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby={{::title}} ng-transclude></div> ";
    angular.module('ng').run(['$templateCache', function($templateCache){
      $templateCache.put('uib/template/progressbar/bar.html', html);
    }]);
    module.exports = 'uib/template/progressbar/bar.html';
  